import "./../styles/LegalPages.css";

function LegalPage(){

return(

<div className="legal-page">

<div className="legal-container">

<h1>
    Mentions légales
</h1>

<section>
    <h2>1. Éditeur</h2>
    <p>Le site FootVision Live, accessible à l'adresse https://footvisionlive.com, est une plateforme spécialisée dans les analyses footballistiques, les statistiques, les compositions de matchs, les pronostics sportifs ainsi que les contenus d'information liés au football.</p>
    <p>L'éditeur du site est :</p>
    <strong>FootVision Live</strong>
    <p>E-mail : contact@footvisionlive.com</p>
    <p>Site Internet : https://footvisionlive.com</p>
</section>

<section>
    <h2>2. Hébergement</h2>
    <p>Le site FootVision Live est hébergé par :</p>
    <strong>Render</strong>
</section>

<section>
    <h2>3. Objet du site</h2>
    <p>FootVision Live met à disposition des utilisateurs notamment :</p>
    <ul>
        <li>des analyses footballistiques ; </li>     
        <li>des statistiques sportives ; </li>
        <li>des scores en direct ; </li>
        <li>des compositions de matchs ; </li>
        <li>des pronostics sportifs ; </li>
        <li>des actualités footballistiques ; </li>
        <li>des contenus réservés aux membres VIP ; </li>
        <li>différents services liés au football. </li>
    </ul>
    <p>L'ensemble de ces contenus est fourni exclusivement à titre informatif.</p>
</section>

<section>
    <h2>4. Accès au site</h2>
    <p>Le site est accessible 24 heures sur 24 et 7 jours sur 7, sauf interruption programmée ou imprévue liée à la maintenance, aux mises à jour, à un cas de force majeure ou à une défaillance technique.</p>
    <p>FootVision Live s'efforce d'assurer une disponibilité optimale sans toutefois pouvoir la garantir en permanence.</p>
</section>

<section>
    <h2>5. Création de compte</h2>
    <p>Certaines fonctionnalités nécessitent la création d'un compte utilisateur.</p>
    <p>Les utilisateurs peuvent créer un compte :</p>
    <ul>
        <li>par adresse e-mail et mot de passe ; </li>
        <li>via leur compte Google lorsque cette fonctionnalité est disponible. </li>
    </ul>
    <p>L'utilisateur s'engage à fournir des informations exactes et à les maintenir à jour.</p>
</section>

<section>
    <h2>6. Compte VIP</h2>
    <p>FootVision Live propose un abonnement VIP donnant accès à des contenus et fonctionnalités supplémentaires.</p>
    <p>Les modalités de souscription, de paiement et de renouvellement sont précisées dans les Conditions Générales d'Utilisation.</p>
</section>

<section>
    <h2>7. Propriété intellectuelle</h2>
    <p>Tous les contenus présents sur FootVision Live, notamment :</p>
    <ul>
        <li>le logo ; </li>
        <li>le nom FootVision Live ; </li>
        <li>les textes ; </li>
        <li>les analyses ; </li>
        <li>les statistiques ; </li>
        <li>les compositions ; </li>
        <li>les graphismes ; </li>
        <li>les vidéos ; </li>
        <li>les photographies ; </li>
        <li>les développements informatiques ; </li>
        <li>la structure du site ; </li>
    </ul>
    <p>sont protégés par les lois relatives à la propriété intellectuelle.</p>
    <p>Toute reproduction, diffusion, adaptation ou exploitation sans autorisation écrite préalable est strictement interdite.</p>
</section>

<section>
    <h2>8. Marques</h2>
    <p>Le nom FootVision Live, son identité visuelle, son logo ainsi que ses éléments graphiques constituent des éléments distinctifs protégés.</p>
    <p>Toute utilisation susceptible de créer une confusion est interdite.</p>
</section>

<section>
    <h2>9. Exactitude des informations</h2>
    <p>FootVision Live met tout en œuvre pour fournir des informations aussi exactes que possible.</p>
    <p>Toutefois :</p>
    <ul>
        <li>certaines statistiques et scores proviennent de fournisseurs tiers ; </li>
        <li>certaines analyses reposent sur des modèles prédictifs ; </li>
        <li>des erreurs peuvent exceptionnellement apparaître. </li>
    </ul>
    <p>Aucune garantie n'est donnée quant à l'exactitude permanente des informations publiées.</p>
</section>

<section>
    <h2>10. Pronostics sportifs</h2>
    <p>Les pronostics, analyses et compositions proposés sur FootVision Live sont publiés exclusivement à des fins informatives.</p>
    <p>Ils ne constituent en aucun cas :</p>
    <ul>
        <li>une garantie de résultat ; </li>
        <li>une promesse de gain ; </li>
        <li>un conseil financier ; </li>
        <li>une incitation au pari. </li>
    </ul>
    <p>Le football demeure un sport imprévisible.</p>
    <p>Même les analyses les plus poussées ne permettent jamais de garantir l'issue d'une rencontre.</p>
</section>

<section>
    <h2>11. Responsabilité de l'utilisateur</h2>
    <p>Chaque utilisateur demeure entièrement responsable :</p>
    <ul>
        <li>de ses décisions ;</li>
        <li>de ses choix de paris sportifs ;</li>
        <li>de l'utilisation qu'il fait des informations publiées.</li>
    </ul>
    <p>FootVision Live ne peut être tenu responsable :</p>
    <ul>
        <li>des pertes financières ;</li>
        <li>des gains manqués ;</li>
        <li>des conséquences directes ou indirectes résultant de l'utilisation des pronostics ou analyses publiés sur la plateforme, dans les limites prévues par la loi.</li>
    </ul>
</section>

<section>
    <h2>12. Limitation de responsabilité</h2>
    <p>FootVision Live ne saurait être tenu responsable :</p>
    <ul>
        <li>des interruptions temporaires du site ;</li>
        <li>des dysfonctionnements techniques ;</li>
        <li>des erreurs provenant de fournisseurs tiers ;</li>
        <li>des attaques informatiques ;</li>
        <li>des pertes de données indépendantes de sa volonté ;</li>
        <li>des conséquences résultant d'une mauvaise utilisation de la plateforme.</li>
    </ul>
</section>

<section>
    <h2>13. Liens externes</h2>
    <p>Le site peut contenir des liens vers des sites tiers.</p>
    <p>FootVision Live n'exerce aucun contrôle sur ces sites et décline toute responsabilité concernant leur contenu, leur disponibilité ou leurs pratiques.</p>
</section>

<section>
    <h2>14. Protection des données</h2>
    <p>Les données personnelles sont traitées conformément à la Politique de confidentialité de FootVision Live.</p>
    <p>Les utilisateurs disposent des droits prévus par la réglementation applicable.</p>
</section>

<section>
    <h2>15. Cookies</h2>
    <p>Le site utilise des cookies afin :</p>
    <ul>
        <li>d'améliorer l'expérience utilisateur ;</li>
        <li>de sécuriser les connexions ;</li>
        <li>de mesurer l'audience ;</li>
        <li>d'assurer certaines fonctionnalités.</li>
    </ul>
    <p>Les modalités sont détaillées dans la Politique relative aux cookies.</p>
</section>

<section>
    <h2>16. Publicités</h2>
    <p>FootVision Live peut diffuser des publicités provenant de partenaires tels que Google AdSense.</p>
    <p>Les annonceurs demeurent seuls responsables des produits ou services proposés.</p>
</section>

<section>
    <h2>17. Utilisation des API</h2>
    <p>Certaines données sportives affichées sur FootVision Live proviennent de fournisseurs spécialisés tels qu'API-SPORTS.</p>
    <p>Ces données restent soumises aux conditions d'utilisation de leurs propriétaires respectifs.</p>
</section>

<section>
    <h2>18. Sécurité</h2>
    <p>FootVision Live met en œuvre des mesures raisonnables destinées à protéger les informations des utilisateurs.</p>
    <p>Toutefois, aucune transmission sur Internet ne peut être garantie comme totalement sécurisée.</p>
</section>

<section>
    <h2>19. Modification des présentes mentions</h2>
    <p>FootVision Live se réserve le droit de modifier les présentes mentions légales à tout moment.</p>
    <p>Les utilisateurs sont invités à les consulter régulièrement.</p>
</section>

<section>
    <h2>20. Droit applicable</h2>
    <p>Les présentes mentions légales sont régies par la législation applicable dans le pays de l'éditeur, sous réserve des règles impératives applicables aux utilisateurs résidant dans d'autres juridictions.</p>
</section>

<section>
    <h2>21. Contact</h2>
    <p>Pour toute question concernant les présentes mentions légales, vous pouvez nous contacter à :</p>
    <strong>contact@footvisionlive.com</strong>
</section>

</div>

</div>

);

}

export default LegalPage;